import instance from '@/utils/instance';

// 获取标签(生命周期)
export function getLifeStandardLabel() {
	return instance({
		url: `/webL_api/essential/api/getLifeStandardLabel`,
		method: 'get'
	});
}

// 获取标签(专业领域)
export function getMajorStandardLabel() {
	return instance({
		url: `/webL_api/essential/api/getMajorStandardLabel`,
		method: 'get'
	});
}

// 获取种类(特种设备)
export function getStandardCategory() {
	return instance({
		url: `/webL_api/essential/api/getStandardCategory`,
		method: 'get'
	});
}

// 获取标准状态
export function getStandardLife() {
	return instance({
		url: `/webL_api/essential/api/getStandardLife`,
		method: 'get'
	});
}

// 获取标准类型
export function getStandardType() {
	return instance({
		url: `/webL_api/essential/api/getStandardType`,
		method: 'get'
	});
}

//获取检索框列表
// export function getSearchList(params) {
// 	return instance({
// 		url: `/webL_api/essential/standardInfo/simpleList`,
// 		method: 'post',
// 		data: params
// 	});
// }

// 获取标准类型(仅标准)
export function getStandardTypeOnlyStandard() {
	return instance({
		url: `/webL_api/essential/api/getStandardTypeSimple`,
		method: 'get'
	});
}

//分类筛选查询列表
export function getSearchList(params) {
	return instance({
		url: `/webL_api/essential/standardInfo/industrySimpleList`,
		method: 'post',
		data: params
	});
}

//标准数量
export function getSearchStandardCount() {
	return instance({
		url: `/webL_api/essential/api/standard/count`,
		method: 'get'
	});
}

//特种设备标准数量
export function getSearchSpecialEquipmentCount() {
	return instance({
		url: `/webL_api/essential/api/standardIndustry/count`,
		method: 'post',
		data: { 'industryId': [1] }
	});
}
